export const staffingStatsPortalId = "staffing-stats-portal";